import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import DashboardEdit from "./DashboardEdit";
import { getPreBaseRoute } from "../../../../components";
import { getDashboardBasePath } from "../Advisor/AdvisorRoutes";
const DashboardRoutes = () => (_jsx(Switch, { children: _jsx(Route, { component: DashboardEdit, path: `${getPreBaseRoute() + getDashboardBasePath()}/edit/:id` }) }));
export default DashboardRoutes;
